import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useFormikContext } from 'formik';
import { useCallback, useMemo } from 'react';
import Tab from '../../elements/Tab/Tab';
import Tabs from '../../elements/Tab/Tabs';
import SignalFormTab from './SignalFormTab';
const textStyles = css `
  text-align: center;
  width: 100%;

  .errorText {
    color: red;
  }

  .infoText {
    padding: 10px;
    margin: 10px 0;
    font-size: 14px;
    text-align: left;
    color: white;
    background-color: #5f5f5f;
    border-radius: 5px;
  }
`;
const tabStylesAddition = css `
  color: red;
`;
const tabStyles = css `
  display: inline-grid;
  list-style: none;
  padding: 0.5rem 1.5rem;
`;
function SignalsForm() {
    const { values, setFieldValue, errors, } = useFormikContext();
    const tabContainsErrors = useCallback((i) => {
        return !!(errors?.signals && errors?.signals[i]);
    }, [errors]);
    const signalFormTabs = useMemo(() => {
        const signalTabs = values.signals.length > 0
            ? values.signals.map((signal, i) => (_jsx(Tab
            // eslint-disable-next-line react/no-array-index-key
            , { tabid: `${i}`, tabstyles: tabContainsErrors(i) ? tabStylesAddition : tabStyles, render: () => (_jsxs("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        fontSize: '11px',
                    }, children: [_jsxs("span", { children: ["\uD835\uDEC5", _jsx("sub", { children: signal.x.nucleus }), ": ", signal.x.delta.toFixed(2)] }), _jsxs("span", { children: ["\uD835\uDEC5", _jsx("sub", { children: signal.y.nucleus }), ": ", signal.y.delta.toFixed(2)] })] })), children: _jsx(SignalFormTab, { signalIndex: i }) }, `signalForm_zone${i}`)))
            : [];
        return signalTabs;
    }, [tabContainsErrors, values.signals]);
    const tapClickHandler = useCallback(({ tabid }) => {
        setFieldValue('activeTab', tabid);
    }, [setFieldValue]);
    const handleDeleteSignal = useCallback(({ tabid }) => {
        const _signals = values.signals.filter((_signal, i) => i !== Number(tabid));
        setFieldValue('signals', _signals);
    }, [setFieldValue, values.signals]);
    return (_jsxs("div", { children: [_jsx("div", { css: textStyles }), _jsx(Tabs, { activeTab: values.activeTab, onClick: tapClickHandler, onDelete: handleDeleteSignal, children: signalFormTabs })] }));
}
export default SignalsForm;
